import dark from './dark'

export default {
    dark,
}
